import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Legacy /payment route — billing is handled in Settings modal + Stripe.
 */
const Payment = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    navigate('/dashboard/settings?plans=1', {
      replace: true,
      state: { from: '/payment', prior: location.state },
    });
  }, [navigate, location.state]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 text-slate-600 text-sm">
      Redirecting to plan & billing…
    </div>
  );
};

export default Payment;
